export const IsDev = process.env.REACT_APP_STAGE === "dev"

type ApiEndpoint = {
    name: string,
    endpoint: string,
    region: string
}

type CognitoConfigs = {
    mandetorySignIn: boolean;
    region: string;
    userPoolId: string;
    identityPoolId: string;
    userPoolWebClientId: string;
}

type StorageConfig = {
    region: string;
    bucket: string;
    identityPoolId: string;
}

type AppConfigs = {
    Auth: CognitoConfigs;
    Storage?: StorageConfig;
    API: {
        endpoints: ApiEndpoint[]
    }

}

export const UserAPI = "FB-USER-API";

export const FBConfig = IsDev ? "368861643890473" : "515990505564621"

const prodConfig: AppConfigs = {
    Auth: {
        mandetorySignIn: true,
        region: "eu-central-1",
        userPoolId: "eu-central-1_ZnsLHpkuP",
        identityPoolId: "eu-central-1:5666ccf9-80ee-40ba-bb09-cc1b1f0fd4c4",
        userPoolWebClientId: "2mnaqgq2obgcpn1vrlhqikv0tm",
    },
    API: {
        endpoints: [{
            name: UserAPI,
            endpoint: process.env.REACT_APP_API === "local" ? "http://localhost:3000/prod" : "https://56o6x8ixfk.execute-api.eu-west-1.amazonaws.com/prod",
            region: "eu-west-1"
        }]
    }
}

const devConfig: AppConfigs = {
    Auth: {
        mandetorySignIn: true,
        region: "eu-central-1",
        userPoolId: "eu-central-1_601mFbgwX",
        identityPoolId: "eu-central-1:f2c88ca8-efe3-41d8-9f30-452e71f75798",
        userPoolWebClientId: "65qau2r96c9uj4qfqi28k384so"
    },
    API: {
        endpoints: [{
            name: UserAPI,
            endpoint: process.env.REACT_APP_API === "local" ? "http://localhost:3000/dev" : "https://gxzdlc7dfh.execute-api.eu-west-1.amazonaws.com/dev",
            region: "eu-west-1"
        }]
    }
}

export default IsDev ? devConfig : prodConfig